import React from "react";

import PageHeading from "2g-page-heading";

import { RezervaceTable } from "b2b/components/rezervace-table/RezervaceTable";
import getNejblizsiRezervaceProps from "b2b/components/rezervace-table/utils/getNejblizsiRezervaceProps";

export function RezervaceTableExample() {
  return (
    <>
      <PageHeading>RezervaceTable typZdroje=ZEL_INFRASTUKTURA</PageHeading>
      <div data-testid="RezervaceTable">
        <RezervaceTable
          {...getNejblizsiRezervaceProps()}
          typZdroje={{
            name: "ZEL_INFRASTUKTURA",
            vyznamCz: "Žel.infrastruktura",
            popisCz: "Železniční infrastruktura",
            vyznamEn: "Railway infrastructure",
            popisEn: "Railway infrastructure"
          }}
        />
      </div>
    </>
  );
}

RezervaceTableExample.propTypes = {};

export default React.memo(RezervaceTableExample);
